<div id="atestados" class="container-fluid mb-1">
  <div class="row">
    <div class="col-md-2">
      <fieldset class="panel">
        <legend>Atestados</legend>
        <div class="table-responsive">
          <table class="table table-sm table-striped table-hover">
            <thead>
            <tr>
              <th scope="col">Tipo</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let atestado of atestados" (click)="setAtestadoAtual(atestado)">
              <td [class.table-active]="atestado == atestadoSelecionado">{{ atestadoService.obterDescricaoAtestadoPorTipo(atestado.ind_Tipo) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </fieldset>
    </div>
    <div class="col">
      <p class="situacao">Atestados do Dia - {{ atestadoSelecionado.data_Dispensa | date: 'dd/MM/yyyy' }} {{ marcacaoAtual.isTravada ? 'Travados' : '' }}</p>
      <div class="row" *ngIf="atestadoSelecionado.seq >= 0">
        <div class="col-md-4">
          <fieldset class="panel">
            <legend>Tipo de Atestado/Declaração</legend>
            <div class="form-check" *ngFor="let tipo of tiposAtestado">
              <input class="form-check-input" type="radio" name="ind_Tipo" value="{{tipo}}" id="tipoAtestado{{tipo}}"
                     [(ngModel)]="atestadoSelecionado.ind_Tipo" [disabled]="marcacaoAtual.isTravada">
              <label class="form-check-label" for="tipoAtestado{{tipo}}">
                {{ atestadoService.obterDescricaoAtestadoPorTipo(tipo) }}
              </label>
            </div>
          </fieldset>
        </div>
        <div class="col-md-8">
          <fieldset class="panel">
            <legend>Atendimento</legend>
            <div class="container">
              <div class="row mb-3">
                <div class="col-md-3">
                  <label for="dias_Dispensa" class="form-label">Dias de Afastamento</label>
                </div>
                <div class="col-md-2">
                  <input type="number" class="form-control form-control-sm" id="dias_Dispensa"
                         [(ngModel)]="atestadoSelecionado.dias_Dispensa" [disabled]="marcacaoAtual.isTravada">
                </div>
                <div class="col-md-2">
                  <label for="motivo_Declaracao" class="form-label">Motivo Declaração <span *ngIf="!marcacaoAtual.isTravada" class="text-danger">*</span></label>
                </div>
                <div class="col-md-5">
                  <input type="text" class="form-control form-control-sm" id="motivo_Declaracao"
                         [(ngModel)]="atestadoSelecionado.motivo_Declaracao" [disabled]="marcacaoAtual.isTravada" [required]="!marcacaoAtual.isTravada">
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-3">
                  <label for="hora_Inicial_Atd" class="form-label">Hora Início Atd.</label>
                </div>
                <div class="col-md-2">
                  <input type="time" class="form-control form-control-sm" id="hora_Inicial_Atd" step="60"
                         [(ngModel)]="atestadoSelecionado.hora_Inicial_Atd" [disabled]="marcacaoAtual.isTravada">
                </div>
                <div class="col-md-2">
                  <label for="hora_Final_Atd" class="form-label">Hora Fim Atd.</label>
                </div>
                <div class="col-md-2">
                  <input type="time" class="form-control form-control-sm" id="hora_Final_Atd" step="60"
                         [(ngModel)]="atestadoSelecionado.hora_Final_Atd" [disabled]="marcacaoAtual.isTravada">
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-3">
                  <label for="codigoCid" class="form-label">CID-10</label>
                </div>
                <div class="col-md-2 input-group">
                  <input type="text" class="form-control form-control-sm" id="codigoCid" [(ngModel)]="codigoCid" [disabled]="marcacaoAtual.isTravada">
                  <button type="button" class="btn btn-sm btn-primary" (click)="abrirModal(modalCid)" [disabled]="marcacaoAtual.isTravada">Confirmar</button>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-md-4">
                  <label for="nome_Encaminhamento" class="form-label">Nome do Acompanhante</label>
                </div>
                <div class="col-md-md-8">
                  <input type="text" class="form-control form-control-sm" id="nome_Encaminhamento"
                         [(ngModel)]="atestadoSelecionado.nome_Encaminhamento" [disabled]="marcacaoAtual.isTravada">
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="row gap-3 mt-3 p-3">
        <div class="col">
          <button class="btn btn-primary w-100" (click)="novo()" [disabled]="marcacaoAtual.isTravada">Novo Atestado</button>
        </div>
        <div class="col">
          <button class="btn btn-primary w-100" (click)="salvar()" [disabled]="marcacaoAtual.isTravada">Salva</button>
        </div>
        <div class="col">
          <button class="btn btn-primary w-100" (click)="excluir()" [disabled]="marcacaoAtual.isTravada">Exclui Atestado</button>
        </div>
        <div class="col">
          <button class="btn btn-primary w-100" (click)="imprimir()">Impressão</button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #modalCid let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Buscar CID-10</h4>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="table-responsive">
        <table class="table table-sm table-striped table-hover">
          <thead>
          <tr>
            <th scope="col">Código</th>
            <th scope="col">Descricao</th>
            <th scope="col">Ação</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let cid of codigosCid">
            <td>{{ cid.cid_10 }}</td>
            <td>{{ cid.descricao_Cid }}</td>
            <td><button type="button" class="btn btn-sm btn-primary" (click)="selecionarCid(cid); modal.dismiss('Cross click')">Selecionar</button></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.close('Fechar')">Fechar</button>
    </div>
  </div>
</ng-template>

<ng-template #modalCid let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Buscar CID-10</h4>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="table-responsive">
        <table class="table table-sm table-striped table-hover">
          <thead>
          <tr>
            <th scope="col">Código</th>
            <th scope="col">Descricao</th>
            <th scope="col">Ação</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let cid of codigosCid">
            <td>{{ cid.cid_10 }}</td>
            <td>{{ cid.descricao_Cid }}</td>
            <td><button type="button" class="btn btn-sm btn-primary" (click)="selecionarCid(cid); modal.dismiss('Cross click')">Selecionar</button></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.close('Fechar')">Fechar</button>
    </div>
  </div>
</ng-template>
